import { isNumber } from "./utils/index.js";

/** Erlaubte Attribut-Keys für Produktdaten (pid, name, value, currency, category). */
export const DATALAYER_ITEM_PARAMS = ["pid", "name", "value", "currency", "category"];

/**
 * Erzeugt ein <dl-product>-Element aus Rohdaten (Iterable von [key, value]-Paaren); filtert nach paramKeys.
 *
 * @param {Iterable<[string, string]>} data – z. B. Object.entries(obj)
 * @param {string[]} paramKeys – z. B. DATALAYER_ITEM_PARAMS
 */
export function getDlProductElement(data, paramKeys) {
    const dlProduct = document.createElement("dl-product");
    const productParams = getEventParams(data, paramKeys);
    const entries = Object.entries(productParams);
    for (const [key, value] of entries) {
        dlProduct.setAttribute(key, value);
    }
    return dlProduct;
}

/**
 * Filtert aus data (Iterable von [key, value]) nur Einträge, deren key in params vorkommt; Zahlen-Strings werden zu Number.
 */
export function getEventParams(data, params) {
    const eventParams = {};
    for (const [key, value] of data) {
        const isValidParam = params.includes(key);
        const datalayerValue = getEventValue(value);
        if (isValidParam) {
            Object.assign(eventParams, {
                [key]: datalayerValue
            })
        }
    }
    return eventParams;
}

/**
 * Gibt originalValue als Number zurück, falls es eine Zahl ist, sonst unverändert.
 */
export function getEventValue(originalValue) {
    const numericValue = isNumber(originalValue);
    if (numericValue) {
        return Number(originalValue);
    }
    return originalValue;
}

/**
 * Bestätigt ein per success-signal-required zurückgehaltenes dl-event: Merkur sendet es erst bei "success".
 * element muss der Button mit dl-event oder einer seiner Vorfahren zum Klickzeitpunkt sein.
 *
 * @param {HTMLElement} element
 * @param {boolean} erfolgreich – false verwirft das Event
 */
export function sendeDlSignal(element, erfolgreich) {
    element.setAttribute("dl-signal", erfolgreich ? "success" : "error");
}
